import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import type {
  GetProcessorQuery,
  GetProcessorQueryVariables,
} from '#graphql/generated';

export const GET_PROCESSOR: TypedDocumentNode<
  GetProcessorQuery,
  GetProcessorQueryVariables
> = gql`
  query GetProcessor($id: String!) {
    processor(id: $id) {
      id
      fileId
      createdAt
      updatedAt
      fileRefs {
        id
        sortOrder
        role
      }
    }
  }
`;
